import React, { useState } from "react";
import Draggable from "react-draggable";
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import LocationCity from '@mui/icons-material/LocationCity';
import { MdAgriculture, MdHolidayVillage, MdLocationCity } from "react-icons/md";
import { FaRoad } from "react-icons/fa";
import { Backdrop, Button, Tooltip, Typography } from "@mui/material";
import { Layers, People, Satellite, Water } from "@mui/icons-material";
import { useResponsive } from "../../contexts/ResponsiveContext";

import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';


type SelectedMapStyle = "basic" | "satellite";

const boundaries = [
  'Admin',
  'Block',
  'Satellite',
];

interface LayersComponentProps {
  selectedLayer: string[];
  setSelectedLayer: React.Dispatch<React.SetStateAction<string[]>>;
  selectedMapStyle: SelectedMapStyle;
  setSelectedMapStyle: React.Dispatch<React.SetStateAction<SelectedMapStyle>>;
  ifRegion: boolean;
  setIfRegion: React.Dispatch<React.SetStateAction<boolean>>;
}

const LayersComponent: React.FC<LayersComponentProps> = ({ selectedLayer, setSelectedLayer, selectedMapStyle, setSelectedMapStyle, ifRegion, setIfRegion }) => {
  const { isMobile } = useResponsive();
  const isSelected = (label: string) =>
    label === 'Satellite'
      ? selectedMapStyle === 'satellite'
      : label === 'Panchayat'
        ? ifRegion
        : selectedLayer.includes(label);

  const handleSelect = (label: string) => {
    if (label === 'Panchayat') {
      setIfRegion(!ifRegion);
      return;
    } else if (label === 'Satellite') {
      setSelectedMapStyle(selectedMapStyle === 'basic' ? 'satellite' : 'basic');
      return;
    }
    setSelectedLayer((prev: string[]) =>
      prev.includes(label)
        ? prev.filter((item: string) => item !== label) // Remove if already selected
        : [...prev, label] // Add if not selected
    );
  };

  const icons = [
    { label: 'Panchayat', icon: <People /> },
    { label: 'Satellite', icon: <Satellite /> },
    { label: 'Inundation', icon: <Water /> },
    { label: 'Buildings', icon: <LocationCity /> },
    { label: 'Landcover', icon: <MdAgriculture /> },
    { label: 'Roads', icon: <FaRoad /> },
  ];

  const [isHighScale, setIsHighScale] = React.useState(
    window.devicePixelRatio >= 1.5
  );
  React.useEffect(() => {
    const handleScaleChange = () => {
      setIsHighScale(window.devicePixelRatio >= 1.5);
    };

    window.addEventListener("resize", handleScaleChange);
    return () => window.removeEventListener("resize", handleScaleChange);
  }, []);

  if (isMobile) {

    return (
      <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
        <SpeedDial
          ariaLabel="Layers"
          sx={{ position: 'absolute', bottom: 16, right: 16 }}
          icon={
            <Layers />
          }
        >
          {icons.map((action) => (
            // const isSelected = selectedLayer.includes(action.label);
            <SpeedDialAction
              key={action.label}
              icon={action.icon}
              onClick={() => handleSelect(action.label)}
              tooltipOpen={true}
              tooltipTitle={action.label}
              tooltipPlacement="left"
              sx={{
                '& .MuiButtonBase-root': {
                  background: isSelected(action.label) ? '#61cef6ff' : 'rgba(255, 255, 255, 1)',
                },
              }}
            />
          ))}
        </SpeedDial>
      </Box>
    );
  }

  return (
    <Draggable>
      <section className={`flex flex-col text-white font-inter rounded-3xl w-[90px] max-w-[90px] h-auto max-h-[400px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]`}>
        <div className={`flex flex-col pb-4 rounded-[18px] bg-zinc-900 bg-opacity-90`}>
          {/* <header className={`flex flex-col pt-3.5 w-full ${isCollapsed ? "bg-transparent" : "rounded-[22px_22px_1px_1px] bg-zinc-800 bg-opacity-80 shadow-[0px_2px_5px_rgba(0,0,0,0.1)]"}`}> */}
          <div className="pl-5 pt-3 pb-2 text-base leading-none">
            Layers
          </div>
          {/* </header> */}
          <Stack direction="column" spacing={1.1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            {icons.map(({ label, icon }) => (
              <React.Fragment key={label}>
                <IconButton
                  aria-label={label.toLowerCase()}
                  // size="small"
                  size={isHighScale ? "small" : "large"}
                  onClick={() => handleSelect(label)}
                  sx={{
                    backgroundColor: isSelected(label) ? 'white' : '#97C7D6',
                    color: '#2B4A54',
                    '&:hover': {
                      backgroundColor: isSelected(label) ? 'rgba(255, 255, 255, 0.8)' : 'rgba(208, 236, 245, 1)',
                    },
                    borderRadius: '50%',
                    padding: '8px',
                  }}
                >
                  {React.cloneElement(icon, { fontSize: 'inherit' })}
                </IconButton>
                <Typography sx={{ fontFamily: 'sarabun', fontSize: '12px', color: '#fff' }}>{label}</Typography>
              </React.Fragment>
            ))}
          </Stack>
        </div>
      </section>
    </Draggable>
  );
};

export default LayersComponent;